import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLightBulb = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 16,
	viewBox: "0 0 12 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.00097 0.875C5.65597 0.875 5.30347 0.905 4.95097 0.98C2.88097 1.3775 1.23097 3.05 0.840969 5.12C0.480969 7.0775 1.20097 8.8775 2.50597 10.04C2.82847 10.325 3.00097 10.7225 3.00097 11.1425V12.875C3.00097 13.7 3.67597 14.375 4.50097 14.375H4.71097C4.97347 14.825 5.44597 15.125 6.00097 15.125C6.55597 15.125 7.03597 14.825 7.29097 14.375H7.50097C8.32597 14.375 9.00097 13.7 9.00097 12.875V11.1425C9.00097 10.73 9.16597 10.325 9.48097 10.0475C10.5685 9.0875 11.251 7.685 11.251 6.125C11.251 3.2225 8.90347 0.875 6.00097 0.875ZM7.50097 11.375H4.50097V10.625H7.50097V11.375ZM4.50097 12.875V12.125H7.50097V12.875H4.50097ZM8.48347 8.93C8.41597 8.99 8.36347 9.065 8.30347 9.125H3.69097C3.63097 9.0575 3.57847 8.9825 3.51097 8.9225C2.52097 8.0375 2.07847 6.7175 2.31847 5.3975C2.58847 3.9425 3.78847 2.735 5.23597 2.45C5.49097 2.3975 5.74597 2.375 6.00097 2.375C8.07097 2.375 9.75097 4.055 9.75097 6.125C9.75097 7.1975 9.29347 8.2175 8.48347 8.93Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.37597 6.875H5.62597V9.125H6.37597V6.875Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.78559 5.28029L4.25527 5.81062L5.84624 7.40159L6.37657 6.87126L4.78559 5.28029Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.62672 6.87889L6.15704 7.40921L7.74802 5.81824L7.21769 5.28791L5.62672 6.87889Z",
			fill: "white"
		})
	]
});
export default SvgLightBulb;
